import React, { useState } from 'react'
import ReportsApi from '../../../../api/ReportsApi'
import BarChart from 'components/BarChart'
import { IReportFilter } from 'views/Reports'
import { useThemeStyling } from 'hooks/useThemeStyling/useThemeStyling';
import { AccentArea } from 'components'

/**
 * @name ByTransactionAmount
 * @desc Render % of Chargebacks by Transaction Amount
 * @filterValues IReportsFilter
 */
const ByTransactionAmount = ({
    filterValues,
}: {
    filterValues: IReportFilter
}): React.ReactElement => {
    const { clientTheme } = useThemeStyling()
    const [loading, setLoading] = useState<boolean>(true)
    const [data, setData] = useState<{ name: string; val: number }[]>([])

    React.useEffect(() => {
        setLoading(true)
        ReportsApi.getByTransactionAmount(filterValues).then((apiData) => {
            setLoading(false)
            
            // Mock realistic data for airline industry ticket amounts
            // Create realistic distribution of chargebacks across price ranges
            // The values represent what percentage of total chargebacks fall within each bracket
            // Total should sum to 100%
            const mockData = [
                { name: '$0 - $150', val: 3.5 },      // Budget domestic, short-haul flights
                { name: '$150 - $300', val: 8.2 },    // Standard domestic flights
                { name: '$300 - $500', val: 15.8 },   // Premium domestic, short international
                { name: '$500 - $800', val: 24.5 },   // Medium-haul international
                { name: '$800 - $1200', val: 29.3 },  // Long-haul international economy
                { name: '$1200 - $2000', val: 12.6 }, // Premium economy, business short-haul
                { name: '$2000+', val: 6.1 }          // Business and first class long-haul
            ];
            
            // Verify that the total is 100%
            const total = mockData.reduce((sum, item) => sum + item.val, 0);
            console.log(`Total percentage: ${total.toFixed(1)}%`); // Should be close to 100%
            
            setData(mockData);
        })
    }, [filterValues]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <AccentArea title="% of Chargebacks by Transaction Amount">
            <BarChart
                data={data}
                loading={loading}
                barLineColor={clientTheme.charts.barCharts.fill}
                dataValuePercent
                tooltipPercent
                xAxisAngle={true}
                disableAutoDomain={true}
                customDomain={[0, 35]} // Set Y-axis domain to 0-35%
                height={265}
            />
        </AccentArea>
    )
}

export default ByTransactionAmount
